export default [{
  // about visit
  component: function component() {
    return import('pages/checkIn/AboutVisit');
  },
  meta: {
    title: 'route.aboutVisit'
  },
  path: '/check_in/about_visit'
}, {
  // digital receipt
  component: function component() {
    return import('pages/checkIn/DigitalReceipt');
  },
  meta: {
    title: 'route.digitalReceipt'
  },
  path: '/check_in/digital_receipt'
}, {
  // find venue
  component: function component() {
    return import('pages/checkIn/FindVenue');
  },
  meta: {
    title: 'route.findVenue'
  },
  path: '/check_in/find_venue'
}, {
  // Get Started
  component: function component() {
    return import('pages/checkIn/GetStarted');
  },
  meta: {
    title: 'route.getStarted'
  },
  path: '/check_in/get_started'
}, {
  // List Nearby Locations
  component: function component() {
    return import('pages/checkIn/ListNearbyLocations');
  },
  meta: {
    title: 'route.listNearbyLocations'
  },
  path: '/check_in/list_nearby_locations'
}, {
  // Location Check In
  component: function component() {
    return import('pages/checkIn/LocationCheckIn');
  },
  meta: {
    title: 'route.locationCheckIn'
  },
  path: '/check_in/location_check_in'
}, {
  // guest receipt PIN entry screen
  component: function component() {
    return import('pages/checkIn/GuestReceiptPinEntry');
  },
  meta: {
    title: 'route.guestReceiptPinEntry'
  },
  path: '/check_in/guest_receipt_pin_entry'
}, {
  // guest table number entry
  component: function component() {
    return import('pages/checkIn/GuestTableNumberEntry');
  },
  meta: {
    title: 'route.guestTableNumberEntry'
  },
  path: '/check_in/guest_table_number_entry'
}, {
  // team member receipt pin entry
  component: function component() {
    return import('pages/checkIn/TeamMemberReceiptPinEntry');
  },
  meta: {
    title: 'route.teamMemberReceiptPinEntry'
  },
  path: '/check_in/team_member_receipt_pin_entry'
}, {
  // team member table number entry
  component: function component() {
    return import('pages/checkIn/TeamMemberTableNumberEntry');
  },
  meta: {
    title: 'route.teamMemberTableNumberEntry'
  },
  path: '/check_in/team_member_table_number_entry'
}];